var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.title)?_c('customtitle',{staticClass:"mb-12",attrs:{"level":2}},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]):_vm._e(),_c('ul',{staticClass:"products-grid"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }